module.exports = __webpack_public_path__ + "static/img/app-of-the-day-white.89fd13a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-of-the-day/images/app-of-the-day-white.svg
// module id = h0wn
// module chunks = 26